export default function timeout(run, after){
	if (!(run instanceof Function)) return;

	const key = setTimeout(run, after);
	return () => clearTimeout(key);
}
